import { render, staticRenderFns } from "./ExternalGeneralConditionsOfUsage.vue?vue&type=template&id=02239c13&"
import script from "./ExternalGeneralConditionsOfUsage.vue?vue&type=script&lang=js&"
export * from "./ExternalGeneralConditionsOfUsage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports